import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Shell } from "@/pages/Auth";
import { useAuth } from "@/context/AuthContext";
import { api, formatError } from "@/lib/api";

const FIELDS = [
  ["company_name", "Company name", "text", true], ["website", "Company website (https://...)", "url", false],
  ["contact_name", "Your name", "text", true], ["email", "Work email", "email", true], ["password", "Password (min 8 characters)", "password", true],
];

export default function EmployerRegister() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ company_name: "", website: "", contact_name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (user) nav(user.role === "employer" ? "/employer" : "/dashboard", { replace: true }); }, [user, nav]);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try { setUser((await api.post("/employer/register", f)).data); } catch (e2) { setErr(formatError(e2)); setBusy(false); }
  };
  return (
    <Shell title="Hire verified clinical research talent" subtitle="Create an employer account. IDDCR reviews every company before jobs can be posted.">
      <form onSubmit={submit} data-testid="employer-register-form" className="flex flex-col gap-4">
        {FIELDS.map(([k, label, type, req]) => (
          <div key={k} className="flex flex-col gap-2">
            <Label htmlFor={`emp-${k}`}>{label}</Label>
            <Input id={`emp-${k}`} data-testid={`employer-register-${k.replace("_", "-")}-input`} type={type} required={req} minLength={type === "password" ? 8 : undefined}
              value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} />
          </div>
        ))}
        {err && <p data-testid="employer-register-error" className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{err}</p>}
        <Button data-testid="employer-register-submit-btn" type="submit" disabled={busy} className="h-11 rounded-full">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create employer account"}</Button>
        <p className="text-sm text-ink-2">Already registered? <Link to="/login" data-testid="employer-goto-login" className="font-semibold text-aqua hover:underline">Log in</Link> · Learner? <Link to="/register" className="font-semibold text-aqua hover:underline">Join as a learner</Link></p>
      </form>
    </Shell>
  );
}
